/**
 * Product Card Touch Handler
 * Enables second image display on mobile via touch/tap
 */

(function() {
  'use strict';
  
  // Check if device is touch-enabled
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  
  if (!isTouchDevice) return; // Only run on touch devices
  
  let activeCard = null;
  
  function initProductCardTouch() {
    const productCards = document.querySelectorAll('.product-card__image-wrapper');
    
    productCards.forEach(wrapper => {
      const secondImage = wrapper.querySelector('.product-card__image--second');
      if (!secondImage) return; // Skip if no second image
      
      // Add touch event listener
      wrapper.addEventListener('touchstart', function(e) {
        // Don't prevent default to allow scrolling
        
        // If this card is already active, do nothing (allow link to work)
        if (wrapper.classList.contains('touch-active')) {
          return;
        }
        
        // Prevent link navigation on first touch
        e.preventDefault();
        
        // Remove active state from previous card
        if (activeCard && activeCard !== wrapper) {
          activeCard.classList.remove('touch-active');
        }
        
        // Add active state to this card
        wrapper.classList.add('touch-active');
        activeCard = wrapper;
      }, { passive: false });
    });
    
    // Remove active state when touching outside
    document.addEventListener('touchstart', function(e) {
      if (!e.target.closest('.product-card__image-wrapper')) {
        if (activeCard) {
          activeCard.classList.remove('touch-active');
          activeCard = null;
        }
      }
    });
  }
  
  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductCardTouch);
  } else {
    initProductCardTouch();
  }
  
  // Re-initialize when new products are loaded (AJAX)
  document.addEventListener('shopify:section:load', initProductCardTouch);
})();
